import React from 'react'
import {
  LoadableButton as UIKitLoadableButton,
  LoadableButtonProps,
} from '@urbaninfrastructure/react-ui-kit'

export default function LoadableButton(props: LoadableButtonProps) {
  return <UIKitLoadableButton shape="cool" {...props} />
}
